import ApplicationState from '../ApplicationState';
import DOMElementNotFoundError from '../error/DOMElementNotFoundError';
import { triggerCustomEvent } from '../EventTrigger';
import loadIndicator from '../LoadIndicator';

export default class PopupController
{
    protected itemsSelector: string;
    protected container: Element;
    protected remoteUrl: string|null = null;
    protected classes = {
        title: 'js-popup-hint-title',
        text: 'js-popup-hint-text',
    };

    private hintSource: Element;

    constructor(itemsSelector: string, containerSelector: string)
    {
        this.itemsSelector = itemsSelector;
        
        let container = document.querySelector(containerSelector);

        if (container) {
            this.container = container;
        } else {
            throw new DOMElementNotFoundError(
                'Container "' + containerSelector  + '" not found'
            );
        }
    }

    public init()
    {
        document.querySelectorAll(this.itemsSelector).forEach(item => {
            item.addEventListener('click', () => {
                if (item.hasAttribute('opened')) {
                    this.hide();
                    this.hintSource?.removeAttribute('opened');

                    return;
                }

                this.hintSource?.removeAttribute('opened');
                
                item.setAttribute('opened', '');
                this.hintSource = item;

                this.show(this.hintSource);
            });
        });

        ApplicationState.popupHint.getNode().addEventListener('hint-closed', () => {
            this.hintSource?.removeAttribute('opened');
        });
    }

    public show(item: Element)
    {
        if (this.remoteUrl === null) {
            this.showStatic(item);
        } else {
            this.showRemote(item);
        }
    }

    public getTitle(item: Element): string
    {
        let title = item.querySelector('.' + this.classes.title) as HTMLElement;

        return title === null ? '' : title.innerText;
    }

    public getText(item: Element): string
    {
        let text  = item.querySelector('.' + this.classes.text) as HTMLElement;

        return text === null ? '' : text.innerText;
    }

    public hide()
    {
        ApplicationState.popupHint.hide();
    }

    /**
     * Установка этого параметра переключает контроллер на использование XHR-запроса для получения выводимого сообщения.
     * Если параметр не установлен, то поиск сообщения осуществляется внутри узла
     * 
     * @param url 
     */
    public setRemoteUrl(url: string)
    {
        this.remoteUrl = url;
    }

    protected showStatic(item: Element)
    {
        let title = this.getTitle(item);
        let text  = this.getText(item);

        ApplicationState.popupHint.setHint(title, text);
        ApplicationState.popupHint.show(item, this.container);

        this.triggerOpenEvent(item);
    }

    protected showRemote(item: Element)
    {
        let modelId = item.getAttribute('data-model-id');

        if (modelId === null) {
            return;
        }

        if (item.querySelector('.' + this.classes.text) === null) {
            let data = new FormData;
            data.append('id', modelId);
            
            loadIndicator(item);

            ApplicationState.axios.post(this.remoteUrl, data).then(rsp => {
                loadIndicator(item, true);

                if (rsp.status === 200 && typeof rsp.data.text !== 'undefined') {
                    item.appendChild(this.createDataNode(rsp.data.title, true));
                    item.appendChild(this.createDataNode(rsp.data.text));

                    ApplicationState.popupHint.setHint(rsp.data.title, rsp.data.text);
                    ApplicationState.popupHint.show(item, this.container);

                    this.triggerOpenEvent(item);
                }
            }).catch(() => {
                loadIndicator(item, true);
            });
        } else {
            this.showStatic(item);
        }
    }

    protected createDataNode(innerText: string, isHeader: boolean = false)
    {
        let div       = document.createElement('div');
        let classType = isHeader ? this.classes.title : this.classes.text;

        div.classList.add('display_none', classType);
        div.innerText = innerText;

        return div;
    }

    private triggerOpenEvent(item: Element)
    {
        triggerCustomEvent(this.container, 'popup-hint-opened', {
            bubbles: true,
            detail: {source: item}
        });
    }
}
